import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { getReturnToForAuth0Login } from 'utils/postAuthRedirect';
import Login from '../Login';

const PLD_LOGIN_STYLE = {
  societyName: 'PLD Space',
  pageStyle: 'login-page-pld',
  button: {
    icon: 'ni-signin',
    text: 'Login',
  },
  warning: {
    text: 'LoginWarningPld',
    email: 'investors@pldspace.com',
  },
  logo: 'https://www.resources.sttok.com/images/logo-pld-space-light.png',
  accessTitle: 'AccessPld',
  accessText: '',
};

const LoginPLD = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect({
      appState: {
        returnTo: getReturnToForAuth0Login(),
      },
    });
  }, [loginWithRedirect]);

  return <Login customStyle={PLD_LOGIN_STYLE} />;
};

export default LoginPLD;
